export default __webpack_public_path__ + "static/media/selectToken.d1f5030d.png";